import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import LicensesForm from './LicensesForm';

const LicensesFormModal = ({ open, onClose, selectedLicense, onSuccess }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{selectedLicense ? 'Edit License' : 'Add License'}</DialogTitle>
      <DialogContent>
        <LicensesForm
          selectedLicense={selectedLicense}
          onSuccess={() => {
            onSuccess();
            onClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LicensesFormModal;